import { c as _c } from "react/compiler-runtime";
// Tremor Raw Tracker [v0.1.2]
import * as HoverCardPrimitives from "@radix-ui/react-hover-card";
import React from "react";
import { cx } from "@/lib/tailwind-utils";
interface TrackerBlockProps {
  key?: string | number;
  color?: string;
  tooltip?: string;
  hoverEffect?: boolean;
  defaultBackgroundColor?: string;
}
const Block = t0 => {
  const $ = _c(12);
  const {
    color,
    tooltip,
    defaultBackgroundColor,
    hoverEffect
  } = t0;
  const [open, setOpen] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = color || defaultBackgroundColor;
  const t3 = hoverEffect ? "hover:opacity-50" : "";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cx("size-full rounded-[1px]", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <HoverCardPrimitives.Trigger onClick={t1} asChild={true}><div className="size-full overflow-hidden px-[0.5px] transition first:rounded-l-[4px] first:pl-0 last:rounded-r-[4px] last:pr-0 sm:px-px"><div className={t4} /></div></HoverCardPrimitives.Trigger>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== tooltip) {
    t6 = tooltip && <HoverCardPrimitives.Portal><HoverCardPrimitives.Content sideOffset={10} side="top" align="center" avoidCollisions={true} className={cx("w-auto rounded-md px-2 py-1 text-body shadow-md", "text-white", "bg-gray-900")}>{tooltip}</HoverCardPrimitives.Content></HoverCardPrimitives.Portal>;
    $[6] = tooltip;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== open || $[9] !== t5 || $[10] !== t6) {
    t7 = <HoverCardPrimitives.Root open={open} onOpenChange={setOpen} openDelay={0} closeDelay={0}>{t5}{t6}</HoverCardPrimitives.Root>;
    $[8] = open;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
Block.displayName = "Block";
interface TrackerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: TrackerBlockProps[];
  defaultBackgroundColor?: string;
  hoverEffect?: boolean;
}
const Tracker = React.forwardRef<HTMLDivElement, TrackerProps>((t0, forwardedRef) => {
  const $ = _c(22);
  let className;
  let hoverEffect;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      data: t1,
      defaultBackgroundColor: t2,
      className,
      hoverEffect,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = hoverEffect;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    className = $[1];
    hoverEffect = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const data = t3;
  const defaultBackgroundColor = t2 === undefined ? "bg-gray-400" : t2;
  let t4;
  if ($[8] !== className) {
    t4 = cx("group flex h-8 w-full items-center", className);
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== data || $[11] !== defaultBackgroundColor || $[12] !== hoverEffect) {
    let t6;
    if ($[14] !== defaultBackgroundColor || $[15] !== hoverEffect) {
      t6 = (props_0, index) => <Block key={props_0.key ?? index} defaultBackgroundColor={defaultBackgroundColor} hoverEffect={hoverEffect} {...props_0} />;
      $[14] = defaultBackgroundColor;
      $[15] = hoverEffect;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t5 = data.map(t6);
    $[10] = data;
    $[11] = defaultBackgroundColor;
    $[12] = hoverEffect;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[17] !== forwardedRef || $[18] !== props || $[19] !== t4 || $[20] !== t5) {
    t6 = <div ref={forwardedRef} className={t4} {...props}>{t5}</div>;
    $[17] = forwardedRef;
    $[18] = props;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
});
Tracker.displayName = "Tracker";
export default Tracker;
export type { TrackerBlockProps };